import { render, staticRenderFns } from "./PostUser.vue?vue&type=template&id=ea9a2294&scoped=true"
import script from "./PostUser.vue?vue&type=script&lang=js"
export * from "./PostUser.vue?vue&type=script&lang=js"
import style0 from "./PostUser.vue?vue&type=style&index=0&id=ea9a2294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9a2294",
  null
  
)

export default component.exports